import React, { useEffect, useState } from "react";
import {
  SimpleGrid,
  Box,
  Text,
  VStack,
  HStack,
  Spinner,
} from "@chakra-ui/react";
import axios from "axios";
import BoardsButtons, { BoardButton } from "./BoardsButtons";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL } from "./config";
import { a } from "./appColors";

const BoardsOverview = () => {
  const [boards, setBoards] = useState([]);
  const [qualsByBoard, setQualsByBoard] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_API_URL}/api/v1/exam-boards/`)
      .then(async (r) => {
        const list = r.data || [];
        setBoards(list);

        const pairs = await Promise.all(
          list.map(async (b) => {
            const q = await axios.get(
              `${BASE_API_URL}/api/v1/exam-qualifications/by-exam-board-guid/${b.guid}`
            );
            return [b.guid, q.data || []];
          })
        );

        const m = {};
        pairs.forEach(([k, v]) => {
          m[k] = v;
        });
        setQualsByBoard(m);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = (board, qual) => {
    navigate(
      `/subjects?boardGuid=${board.guid}` +
        `&boardName=${encodeURIComponent(board.name || board.code)}` +
        `&qualificationGuid=${qual.guid}` +
        `&qualificationCode=${encodeURIComponent(qual.code || qual.name)}`
    );
  };

  if (loading) {
    return (
      <Box
        w="100%"
        minH="40vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Spinner size="lg" color={a.accent} />
      </Box>
    );
  }

  return (
    <Box pt = "45px">
      {/* Title + paragraph */}
      <Box pt = "45px" mb={{ base: 6, md: 8 }}>
        <Text
          color={a.text}
          fontSize="28px"
          fontWeight="500"
          lineHeight="normal"
          mb="8px"
        >
          Choose Your Board Exam Qualification
        </Text>
        <Text
          color={a.text}
          fontSize="12px"
          fontWeight="300"
          lineHeight="normal"
          maxW="560px"
        >
          You can choose to download papers or solve them in the dashboard and
          get help with instant marking and feedback to better your work
          gradually.
        </Text>
      </Box>

      {/* Cards grid */}
      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={{ base: "18px", md: "24px" }}
      >
        {boards.map((b) => (
          <Box
            key={b.guid}
            minWidth="425px"
            p={{ base: "32px 24px 18px", md: "48px 72px 24px" }}
            borderRadius="14px"
            border="1px solid" borderColor={a.border}
            bg={a.surface}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            gap="35px"
          >
            <VStack spacing="35px">
              <Text
                color={a.text}
                textAlign="center"
                fontSize="18px"
                fontWeight="500"
              >
                {b.abbreviation|| b.abbreviation}
              </Text>
              <HStack
                spacing="12px"
                flexWrap="wrap"
                justify="center"
              >
                {(qualsByBoard[b.guid] || []).map((q) => (
                  <BoardButton
                    key={q.guid}
                    label={q.code || q.name}
                    onClick={() => handleSelect(b, q)}
                  />
                ))}
              </HStack>
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default BoardsOverview;


